import { postFetch } from '../fetch';
import { apiConfig } from '../config';
import { NOTIFICATION_TYPE } from '../../../typings';

export type CreateNotificationRequest = {
    target_users_ids: number[],
    type_slug: NOTIFICATION_TYPE;
    close_duplicates?: boolean;
    data?: unknown;
};

export function createNotification(
    request: CreateNotificationRequest
): Promise<void> {
    const { apiCreateNotification } = apiConfig.getStaticUrls();

    return postFetch(apiCreateNotification, request);
}
